import { Component, Input, ViewChild } from '@angular/core';
import { NgbCarousel, NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { WagtailFullBleedSliderItemInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-full-bleed-slider-multi',
    templateUrl: './multi.component.html',
    styleUrls: ['./multi.component.scss'],
    standalone: false
})
export class MultiComponent {
  @ViewChild('carousel') carousel?: NgbCarousel
  @Input() slides?: WagtailFullBleedSliderItemInterface[]
  
  constructor(config: NgbCarouselConfig) {
    config.interval = 0
    config.showNavigationArrows = true
    config.showNavigationIndicators = false
  }
  
}
